import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axiosPlugin from '@/plugins/axios.js'
// import store from './store/store.js'
import Toast from "vue-toastification";
// import Vue3EasyDataTable from 'vue3-easy-data-table';
// import 'vue3-easy-data-table/dist/style.css';

// import "vue-easytable/libs/theme-default/index.css";
// import VueEasytable from "vue-easytable";
import PrimeVue from 'primevue/config';
import "primeflex/primeflex.css";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css"; 
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Menubar from 'primevue/menubar';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
let cors = require('cors')
// Vuetify
// import 'vuetify/styles'
// import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'

// const vuetify = createVuetify({
//     components,
//     directives,
// })



createApp(App)
    .use(store)
    .use(router)
    .use(Toast)
    .use(axiosPlugin, {})
    .use(VueSweetalert2)
    .use(cors)
    // .use(VueEasytable)
    .use(PrimeVue)
    .component('InputText', InputText)
    .component('Button', Button)
    .component('Menubar', Menubar)
    .component('Sidebar', Sidebar)
    .component('SplitButton', SplitButton)
.mount('#app')
